import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
export var MAIN_FOOTER_PAGE_KEY = 'main-footer';
export var COMPANY_LINKS = [{
  label: 'COMPANY_ABOUT',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/sobre-nosotros/")
}, {
  label: 'COMPANY_SIGN_UP',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/entrar/")
}];
export var PRODUCT_LINKS = [{
  label: 'PRODUCT_DEVELOPMENT',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/desarrollo-equipos/")
}, {
  label: 'PRODUCT_WORK_ENVIRONMENT',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/clima-laboral/")
}, {
  label: 'PRODUCT_PERFORMANCE',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/evaluaciones-de-desempeno/")
}];
export var RESOURCES_LINKS = [{
  label: 'RESOURCES_BLOG',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/")
}, {
  label: 'RESOURCES_PODCAST',
  href: 'https://open.spotify.com/show/4e4HZuphxpKot9xfaqXt9k'
}, {
  label: 'RESOURCES_DOWNLOABLES',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/business/descargables/")
}, {
  label: 'RESOURCES_COURSES',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/cursos-online/")
}, {
  label: 'RESOURCES_YOUTUBE',
  href: 'https://www.youtube.com/watch?v=dtcQyOsuL3g'
}];
export var HELP_LINKS = [{
  label: 'HELP_PRIVACY',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/legal/politicas-de-privacidad/")
}, {
  label: 'HELP_COOKIES',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/legal/politica-de-cookies/")
}, {
  label: 'HELP_ARCO',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/legal/solicitud-arco/")
}, {
  label: 'HELP_TERMS',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/legal/terminos-y-condiciones/")
}, {
  label: 'HELP_CLAIMS_BOOK',
  href: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/libro-reclamaciones/")
}];